var NewsSubscriptionFormComponent = require("./new-subscription-form.component");
var RecaptchaPopUpComponent = require("../recaptcha/recaptcha-popup.component");

var NewsSubscriptionService = function () {
    var $currentContext = $();
    var moduleOptions = {
        recaptcha: {
            id: "",
            publickKey: ""
        }
    };
    var classMap = {
        error: ".js-new-subscription-error"
    };

    var $error = $();
    var subscriptionForm, recaptchaPopUp;
    var formData;

    function showError(msg) {
        $error.text(msg);
        $error.show();
    }

    function hideError() {
        $error.hide();
    }

    function handlFormSubmit(data) {
        formData = data;
        recaptchaPopUp.show();
        hideError();
    }

    function handleRecaptchaValidation(gResponse) {
        recaptchaPopUp.hide()

        formData.push({
            name: "g-recaptcha-response",
            value: gResponse
        });

        $.ajax({
            type: "POST",
            url: "/nop/customer/SubscribeToNewsLetters",
            data: formData,
            complete: function (data) {
                var subscriptionResult = data.responseJSON;

                if (subscriptionResult.success) {
                    window.location.href = subscriptionResult.value;
                } else {
                    var errorMessage = "An error has occurred.";
                    
                    var hasErrors = subscriptionResult.errors.length;

                    if(hasErrors) {
                        var sourceError = subscriptionResult.errors[0];
                        var hasErrorMessage = !!sourceError.message;

                        if(hasErrorMessage) {
                            errorMessage = sourceError.message;
                        }
                    }

                    showError(errorMessage);
                }

                formData = null;
            },
            error: function () {
                showError("An error has occurred.");
            }
        });
    }

    function bindEvents() {
        subscriptionForm.on("form-updated", hideError);
        subscriptionForm.on("form-submitted", handlFormSubmit);
        
        recaptchaPopUp.on("recaptcha-validated", handleRecaptchaValidation);
    }

    function parseContext() {
        var $subscriptionForm = $(NewsSubscriptionFormComponent.SELECTOR, $currentContext);
        subscriptionForm = new NewsSubscriptionFormComponent();
        subscriptionForm.init($subscriptionForm);

        var $recaptchaPopUp = $(RecaptchaPopUpComponent.SELECTOR, $currentContext);
        recaptchaPopUp = new RecaptchaPopUpComponent();
        recaptchaPopUp.init($recaptchaPopUp, moduleOptions.recaptcha);

        $error = $(classMap.error, $currentContext);
    }

    this.init = function ($context, options) {
        $currentContext = $context || $currentContext;
        $.extend(moduleOptions, options);

        parseContext();
        bindEvents();
    };
};

module.exports = NewsSubscriptionService;
